import { OptimizeResults } from '~/features/x-ray/types/optimize';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { OptimizeRun } from '../../types/sylvanus/model';
import { mapOptimizeResults } from './transformers';

interface Request {
  modelId: Uuid;
  version: number;
  highlightMethod: string;
}

type Response = OptimizeRun;

export const optimizePromptModel = async ({
  modelId,
  version,
  highlightMethod,
}: Request): Promise<OptimizeResults> => {
  const response: Response = await sylvanus.post(
    `/model/${modelId}/version/${version}/optimize`,
  );
  return mapOptimizeResults(response, highlightMethod);
};
